import React, { useState, useEffect } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import { disableUser } from 'services/api';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
}));

const defaultRun = {
  run: '',
  dv: '',
  names: '',
  last_name: '',
  mother_last_name: '',
  email: '',
  roles: [],
};

const EnableUserDialog = props => {
  const { openDialog = false, close, submit, userDelete = defaultRun, organization } = props;
  const classes = addStyle();
  /*  const [idU, setIdU] = useState(''); */
  const [names, setNames] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userDelete) {
      /*  setIdU(userDelete.id); */
      setNames(userDelete.names);
    } else {
      /*  setIdU(''); */
      setNames('');
    }
  }, [userDelete]);

  const onCloseDialog = event => {
    if (loading) {
      event.preventDefault();
      return;
    }

    setLoading(false);
    close();
  };

  const onSubmitClick = () => {
    setLoading(true);

    let auxRoles = [];
    userDelete.roles_user.map((item, index) => {
      auxRoles.push(item.id);
      return null;
    });
    let auxUsr = {
      ...userDelete,
      organization: organization,
      is_active: true,
      roles_user: auxRoles,
      type_user: 'CU',
    };

    disableUser(auxUsr)
      .then(r => {
        toast.success('Usuario habilitado.');
      })
      .catch(err => {
        console.error(err);
        toast.error('No se pudo habilitar el usuario.');
      })
      .finally(e => {
        setLoading(false);
        onCloseDialog();
        submit();
      });
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <CustomToast />
      <DialogTitle className={classes.dialogTitleRoot}> Habilitar Usuario </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <p>Esta seguro que quiere habilitar a {names} </p>
        </Box>
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog} disabled={loading}>
            {' '}
            Cancelar{' '}
          </Button>
          <Box ml={2}>
            <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={loading}>
              {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Habilitar'}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default EnableUserDialog;
